<p
  [ngClass]="{
    'border-error bg-error': type === 'error',
    'border-info bg-info': type === 'info',
    'border-success bg-success': type === 'success',
    'border-warning bg-warning': type === 'warning'
  }"
  class="mb-0 flex w-full border"
>
  <span class="inline-flex px-2 py-3">
    <ng-container [ngSwitch]="type">
      <app-icon *ngSwitchCase="'error'" name="error" class="text-white"></app-icon>
      <app-icon *ngSwitchCase="'info'" name="info" class="text-white"></app-icon>
      <app-icon *ngSwitchCase="'success'" name="check-circle" class="text-white"></app-icon>
      <app-icon *ngSwitchCase="'warning'" name="warning"></app-icon>
    </ng-container>
  </span>
  <span class="inline-flex grow flex-col gap-0.5 bg-white p-3 font-bold">
    <ng-content #labelContainer select="[label]"></ng-content>
    <span class="font-normal"><ng-content select="[message]"></ng-content></span>
  </span>
  <span *ngIf="isDismissible" class="bg-white px-2 py-3">
    <button
      ndt-icon-button
      aria-label="Zamknij"
      i18n-aria-label
      type="button"
      class="text-secondary"
      (click)="dismiss.emit()"
    >
      <app-icon name="close"></app-icon>
    </button>
  </span>
</p>
